import React,{Component} from 'react'
/* props.tab is passed to this component for no other purpose that to trgger a recalculation of the iframe aspect ration */
class Radar extends Component{
  constructor(props){
    super(props)
    this.state = {}
    this.warnName=  this.props.affiliate == 'kotv' ? 'WARN Radar' : 'NextGen Live';
    this.warningPage = this.props.affiliate == 'kotv' ? '/weatheralerts' : '/weatheralerts';
    this.stationRadar = this.props.affiliate == 'kotv' ? '/warn-interactive-live-radar' : '/nextgen-live-radar';
    this.nationalRadar = '/national-radar';
    this.iframeContainer = false
  }


  render(){
    return(
      <div className='radars'>
        <h3>Radars</h3>
        <div className='radar-inner'>
          <a href={this.nationalRadar}>

            <div id="baron-widget-div-N2-4" className="baron-weather-widget" ref={(e) => {
                this.iframeContainer = e
              }} >
              <iframe id="baron-widget-frame-N2-4"
                  name="map-widget"
                  src={this.props.radarIframeSrc}
                  marginHeight="0"
                  frameBorder="0"
                  scrolling="no"
                  onClick={function(){}}
                  >No iframe support
              </iframe>
          </div>

          </a>
          {this.props.affiliate === 'kotv' ? (
            <div className='row'>
              <div className='col-xs-12 text-center'>
                <a href={this.nationalRadar} target='_blank'><button  type='button'>National Radar</button></a>
              </div>
            </div>
          ) : (
            <div className='row'>
              <div className='col-xs-6 text-center'>
                <a href={this.stationRadar} target='_blank'><button type='button'>{this.warnName}</button></a>
              </div>
              <div className='col-xs-6 text-center'>
                <a href={this.nationalRadar} target='_blank'><button  type='button'>National Radar</button></a>
              </div>
            </div>
          )}

        </div>
      </div>
    )
  }
}

export default Radar;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/WeatherTakeover/Radar.js